export default __webpack_public_path__ + "static/media/gallery02.5ab7ca5e.jpg";